import React, { useState } from 'react';
import PropTypes from 'prop-types';
import BootstrapTable from 'react-bootstrap-table-next';
import ModalWindow from '../../common/Modal';
import styles from './UserStoresModal.module.scss';
import Switch from '../../common/Switch';
import Spinner from '../../common/Spinner';
import { fullName } from '../../../utils/textHelper';

function UserStoresModal(props) {
  const { store, users, open = false } = props;
  const usersData = users
    .filter(({ administration_permission }) => administration_permission === 'none')
    .map((user) => user.user);

  const [loadingIds, setLoadingIds] = useState(false);

  const toggleSwitch = (value, id) => {
    setLoadingIds(id);

    if (value) {
      props.submit(store.id, id);
    } else {
      props.deletePermissions(store.id, id);
    }
  };

  const hasPermission = (userId) => {
    const storeId = store.id;

    // find user permissions
    const user = users.find(({ user }) => user.id === userId).user;

    // check if user has permissions to the current store_id
    return user.user_stores.some(({ store_id }) => store_id === storeId);
  };

  const formatAssign = (userId, row) => {
    return props.updatingUsers && loadingIds === userId ? (
      <Spinner size="small" />
    ) : (
      <Switch checked={hasPermission(userId)} onSwitch={(value) => toggleSwitch(value, userId)} />
    );
  };

  if (!users.length || !store) {
    return null;
  }

  const columns = [
    {
      text: 'User Name',
      dataField: 'user',
      formatter: (cell, row) => <span>{fullName(row)}</span>,
    },
    {
      text: 'Assigned to Store',
      dataField: 'id',
      formatter: formatAssign,
    },
  ];

  return (
    <ModalWindow open={open} onClose={props.onClose} center size="large">
      <h2>Assign user to store: {store.name}</h2>
      <hr />

      <div className={styles.body}>
        <BootstrapTable
          data={usersData}
          columns={columns}
          keyField="id"
          striped
          bordered={false}
          hover
          className={styles.container}
        ></BootstrapTable>
      </div>

      <hr />

      <p>Admin users are assigned to all stores</p>
    </ModalWindow>
  );
}

export default UserStoresModal;

UserStoresModal.propTypes = {
  updatingUsers: PropTypes.bool,
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  store: PropTypes.object,
  users: PropTypes.arrayOf(PropTypes.object).isRequired,
  submit: PropTypes.func.isRequired,
  deletePermissions: PropTypes.func.isRequired,
};
